import { useState } from 'react';

const faqs = [
  {
    q: 'What is VigorBuy Spreadsheet?',
    a: 'VigorBuy Spreadsheet is a comprehensive data management resource platform that provides structured templates, guides, and productivity strategies for businesses and professionals. It helps users organize data, automate workflows, and generate actionable insights — whether you are managing ecommerce inventory, financial records, marketing analytics, or project timelines.',
  },
  {
    q: 'How does VigorBuy Spreadsheet work?',
    a: 'VigorBuy Spreadsheet works by offering ready-to-use spreadsheet frameworks tailored to specific business functions. Users can select a template that matches their needs, customize it with their own data, and immediately start benefiting from organized, analyzable information. The platform also provides educational content to help users maximize their spreadsheet efficiency.',
  },
  {
    q: 'Is VigorBuy Spreadsheet secure?',
    a: 'Absolutely. Security is a cornerstone of the VigorBuy Spreadsheet approach. All templates and guides incorporate best practices for data privacy, access control, and secure sharing. We provide clear recommendations on backup strategies, encryption methods, and safe collaboration practices so your sensitive business data remains protected at all times.',
  },
  {
    q: 'Is VigorBuy Spreadsheet better than Excel?',
    a: 'VigorBuy Spreadsheet and Excel serve complementary purposes. While Excel is a general-purpose spreadsheet tool, VigorBuy Spreadsheet provides specialized, business-focused templates and workflows that accelerate specific tasks like ecommerce management, inventory tracking, and sales analytics. Many professionals use both together — Excel for core spreadsheet functionality and VigorBuy Spreadsheet resources for optimized business workflows.',
  },
  {
    q: 'Who should use VigorBuy Spreadsheet?',
    a: 'VigorBuy Spreadsheet is designed for ecommerce sellers, small business owners, operations managers, data analysts, marketing professionals, and anyone who regularly works with structured data. Whether you are a solo entrepreneur tracking orders or a team lead managing complex project data, our resources help you work smarter and faster.',
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-4">
            Frequently Asked Questions
          </h2>
          <div className="w-16 h-1 bg-accent-400 rounded-full mx-auto mb-6"></div>
          <p className="text-foreground-600 text-sm md:text-base">
            Everything you need to know about VigorBuy Spreadsheet
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="rounded-2xl bg-background-50 border border-background-200/70 overflow-hidden transition-all duration-300"
            >
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
              >
                <span className="font-semibold text-foreground-900 text-sm md:text-base pr-4">{faq.q}</span>
                <div className={`w-5 h-5 flex items-center justify-center transition-transform duration-300 ${openIndex === i ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-foreground-500 text-lg"></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${openIndex === i ? 'max-h-96 pb-4' : 'max-h-0'}`}
              >
                <p className="px-5 text-foreground-600 text-sm leading-relaxed">{faq.a}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}